export default {
  header: 'Ereignis-Schlagwörter',
  empty: 'Es wurden noch keine Ereignis-Schlagwörter angelegt.',
  confirmDelete: 'Möchten Sie "{item}" wirklich löschen? Ereignisse, die dieses Schlagwort bereits tragen, behalten es.',
};
